import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { operationApi } from '../../services/api';

export default function OperationDepartmentsPage() {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ name: '', description: '' });

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await operationApi.departments.list();
      setDepartments(res.data?.data || []);
    } catch (err) { console.error(err); } finally { setLoading(false); }
  };

  useEffect(() => { fetchData(); }, []);

  const openCreate = () => { setEditing(null); setForm({ name: '', description: '' }); setShowForm(true); };
  const openEdit = (dept) => { setEditing(dept); setForm({ name: dept.name, description: dept.description || '' }); setShowForm(true); };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) return alert('Nama departemen wajib diisi');
    setSaving(true);
    try {
      if (editing) {
        await operationApi.departments.update(editing.id, { name: form.name, description: form.description });
      } else {
        await operationApi.departments.create({ name: form.name, description: form.description });
      }
      setShowForm(false);
      fetchData();
    } catch (err) {
      alert(err.response?.data?.message || 'Gagal menyimpan');
    } finally { setSaving(false); }
  };

  const handleDelete = async (dept) => {
    if (!window.confirm(`Hapus departemen "${dept.name}"?`)) return;
    try {
      await operationApi.departments.delete(dept.id);
      fetchData();
    } catch (err) { alert('Gagal menghapus'); }
  };

  return (
    <AdminLayout active="Departemen">
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-lg font-semibold text-gray-800 mb-1">Departemen</h1>
            <p className="text-sm text-gray-500 mt-1">Data master departemen/bagian pekerja operasi</p>
          </div>
          <button onClick={openCreate} className="px-4 py-2 bg-brand text-white rounded-lg hover:bg-brand-dark">+ Tambah Departemen</button>
        </div>

        {loading ? <div className="text-center py-10 text-gray-500">Loading...</div> : (
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Nama Departemen</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                  <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">Aksi</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {departments.map((dept) => (
                  <tr key={dept.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium text-gray-900">{dept.name}</td>
                    <td className="px-4 py-3"><span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-700">Aktif</span></td>
                    <td className="px-4 py-3 text-right space-x-2">
                      <button onClick={() => openEdit(dept)} className="text-blue-600 hover:text-blue-800 text-sm">Edit</button>
                      <button onClick={() => handleDelete(dept)} className="text-red-600 hover:text-red-800 text-sm">Hapus</button>
                    </td>
                  </tr>
                ))}
                {departments.length === 0 && <tr><td colSpan={3} className="px-4 py-8 text-center text-gray-400">Belum ada departemen</td></tr>}
              </tbody>
            </table>
          </div>
        )}

        {showForm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center z-50 p-4 overflow-y-auto" onClick={() => setShowForm(false)}>
            <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-lg relative" onClick={e => e.stopPropagation()}>
              <button onClick={() => setShowForm(false)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl leading-none z-10">&times;</button>
              <h2 className="text-lg font-bold mb-4 pr-8">{editing ? 'Edit Departemen' : 'Tambah Departemen'}</h2>
              <form onSubmit={handleSave} className="space-y-4">
                {editing && (
                  <div><label className="block text-sm font-medium text-gray-700 mb-1">Departemen Saat Ini</label><input disabled value={editing?.name || ''} className="w-full border border-gray-300 rounded-lg px-3 py-2 bg-gray-50" /></div>
                )}
                <div><label className="block text-sm font-medium text-gray-700 mb-1">{editing ? 'Nama Departemen Baru' : 'Nama Departemen'} *</label><input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2" placeholder="contoh: Operasional, Teknisi, Administrasi" autoFocus /></div>
                <div><label className="block text-sm font-medium text-gray-700 mb-1">Deskripsi</label><textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2" rows={2} placeholder="Deskripsi singkat departemen" /></div>
                <div className="flex justify-end gap-3 pt-4">
                  <button type="button" onClick={() => setShowForm(false)} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700">Batal</button>
                  <button type="submit" disabled={saving} className="px-4 py-2 bg-brand text-white rounded-lg hover:bg-brand-dark disabled:opacity-50">{saving ? 'Menyimpan...' : 'Simpan'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}